/* eslint-disable react/jsx-no-undef */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react'
import moment from 'moment';
import CardHeader from '../../components/CardHeader'
import { dataService } from '../../services/data.services';
import ApplicationDetails from './components/ApplicationDetails';
import TopBar from './components/Topbar';
import { useLocation, useSearchParams } from 'react-router-dom';
import LoadingOverlay from "react-loading-overlay-ts";
import LineGraph from './components/Graphs/LineGraph';
import DoughnutGraph from './components/Graphs/DoughnutGraph';

function Dashboard() {
    const location = useLocation()
    const [loadingDetails, setLoadingDetails] = useState(true);
    const [graphDetails, setGraphDetails] = useState([])
    const [searchParams, setSearchParams] = useSearchParams({});
    const falseLoadingState = {
        number_of_merchants_onboarded: false,
        payouts: false,
        number_of_products_added: false,
        number_of_products_scanned: false,
        number_of_stores: false,
        number_of_orders_placed: false,
        commission_earned: false,
        number_of_items_added_to_cart: false,
        products_with_nft: false
    }
    const [loading, setLoading] = useState({
        number_of_merchants_onboarded: true,
        payouts: true,
        number_of_products_added: true,
        number_of_products_scanned: true,
        number_of_stores: true,
        number_of_orders_placed: true,
        commission_earned: true,
        number_of_items_added_to_cart: true,
        products_with_nft: true
    });

    const initialFilterValue = {
        number_of_merchants_onboarded: {
            email_address: 'null',
            city: null,
            duration: "seven_days",
        }, payouts: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }, number_of_products_added: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }, number_of_products_scanned: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }, number_of_stores: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }, number_of_orders_placed: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }, commission_earned: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }, number_of_items_added_to_cart: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        },
        products_with_nft: {
            email_address: 'null',
            merchant: null,
            city: null,
            duration: "seven_days",
        }
    }
    const [selectedFilter, setSelectFilter] = useState(initialFilterValue)
    const [selectedCity, setSelectedCity] = useState('');
    const [cityList, setCityList] = useState([])
    const [selectedMerchant, setSelectedMerchant] = useState('');
    const [MerchantList, setMerchantList] = useState([])
    const [totalCity, setTotalCity] = useState()
    const [totalMerchants,setTotalMerchants] = useState()

    const initialDate = {
        from_date: '',
        end_date: ''
    }
    const initialDateError = {
        from_date: '',
        end_date: ''
    }
    const [DateRange, SetDateRange] = useState(initialDate);
    const [DateRangeError, SetDateRangeError] = useState(initialDateError)

    const handleDatePickerValidation = () => {
        let error = []
        const errorState = { ...DateRangeError }
        Object.keys(DateRangeError).map((item) => {
            switch (true) {
            case item === 'from_date' && DateRange['end_date'] === '':
                // eslint-disable-next-line indent
                    // eslint-disable-next-line indent
                    if (DateRange[item] !== '' && DateRange['end_date'] === '') {
                    errorState['end_date'] = 'End date is required'
                    error.push(item)

                }
                break

            case item === 'end_date' && DateRange['from_date'] === '':
                if (DateRange[item] !== '' && DateRange['from_date'] === '') {
                    errorState['from_date'] = 'Start date is required'
                    error.push(item)

                }
                break
                // case item === 'update_start' && DateRange['update_end'] === '':
                //     if (DateRange[item] !== '' && DateRange['update_end'] === '') {
                //         errorState['update_start'] = 'End date is required'
                //         error.push(item)

                //     }
                //     break
                // case item === 'update_end' && DateRange['update_start'] === '':
                //     if (DateRange[item] !== '' && DateRange['update_start'] === '') {
                //         errorState['update_start'] = 'Start date is required'
                //         error.push(item)

            //     }
            //     break
            case DateRange['from_date'] !== '' && DateRange['end_date'] !== '':

                if ((DateRange['from_date'] !== '' && DateRange['end_date'] !== '') && !moment(DateRange['from_date']).isSameOrBefore(moment(DateRange['end_date']))) {
                    errorState['from_date'] = 'End date should be greater than start date'
                    error.push(item)

                }
            // case DateRange['update_start'] !== '' && DateRange['update_end'] !== '':

            //     if ((DateRange['update_start'] !== '' && DateRange['update_end'] !== '') && !moment(DateRange['update_start']).isSameOrBefore(moment(DateRange['update_end']))) {
            //         errorState['update_start'] = 'End date should be greater than start date'
            //         error.push(item)
            //     }
            }
        })
        SetDateRangeError(errorState)
        return error.length > 0
    }

    const handleApplyFilter = (clear) => {
        let params = Object.fromEntries(searchParams);
        if (clear) {

            if (!params.from_date && !params.to_date) {
                return;
            }
            setLoadingDetails(true);
            SetDateRange(initialDate);
            delete params.from_date
            delete params.to_date
            SetDateRangeError(initialDateError)
            setSelectFilter((prev) => ({
                ...prev,
                "from_date": "",
                "to_date": ""
            }))
            setSearchParams({ ...params })// Update state to clear selected dates
            return;
        }

        if (DateRange['from_date'] !== '' && DateRange['end_date'] !== '') {
            setLoadingDetails(true);
            params.from_date = moment(DateRange['from_date']).unix()
            params.to_date = moment(DateRange['end_date']).unix()
        }

        SetDateRangeError(initialDateError)
        setSearchParams({ ...params })
    }

    const handleSetFilterValues = async (values, GraphKey, key) => {
        let filter_values = selectedFilter[GraphKey]
        if (key !== "merchant") {
            if (filter_values[key] === values) {
                return;
            }
        }
        setLoading((prev) => ({
            ...prev,
            [GraphKey]: true
        }))
        if (key === "merchant") {
            filter_values['email_address'] = values.email_address
            filter_values["merchant"] = values.name,
            filter_values["city"] = values.city,
            setSelectFilter((prev) => ({
                ...prev,
                [GraphKey]: filter_values
            }))
        } else {
            filter_values[key] = values
            setSelectFilter((prev) => ({
                ...prev,
                [GraphKey]: filter_values
            }))
        }

    }
    const handleMercnantChange = async (MerchantName, componentName) => {
    }


    const handleFetch = useCallback(async () => {
        let endpoint = ""
        Object.keys(selectedFilter).map((item) => {
            let itemArray = []
            Object.keys(selectedFilter[item]).map((item_keys) => {
                if(item_keys !== 'merchant') {
                    itemArray.push(selectedFilter[item][item_keys] === null ? "null" : encodeURIComponent(selectedFilter[item][item_keys] ))
                }
            })
            endpoint += `&${item}=${itemArray.join(",")}`
        })
        try {
            const res = await dataService.GetAPI(`dashboard/admin-analytics?${endpoint}${searchParams.get("from_date") === null ? "" : `&${searchParams.toString()}`}`);
            setGraphDetails(res?.data?.data);
            setLoading(falseLoadingState);
            setLoadingDetails(false);

        } catch (error) {
            console.log(error);
            setLoading(falseLoadingState);
            setLoadingDetails(false);
        }
    }, [selectedFilter, searchParams]);


    const handleGetCities = async () => {
        try {
            const response = await dataService.GetAPI('merchant-users/list?city_list=true');
            setCityList(response?.data?.data);
            setTotalCity(response?.data?.total_count)
        } catch {
            console.log(error);
        }
    }
    const handleGetMerchants = async () => {
        try {
            const response = await dataService.GetAPI('merchant-users/list');
            setTotalMerchants(response?.data?.total_count)
            setMerchantList(response?.data?.data)
        } catch {
            console.log(error);
        }
    }
    useEffect(() => {
        handleGetCities();
        handleGetMerchants();
    }, [])


    const handleSetDate = (key, value) => {
        SetDateRangeError(initialDateError)
        const dateCopy = { ...DateRange }
        dateCopy[key] = value;
        SetDateRange(dateCopy)
    }

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    useEffect(() => {
        const copyDate = { ...DateRange }
        let params = Object.fromEntries(searchParams);
        if ((params['from_date'] && params['end_date']) && params['from_date'] !== '' && params['end_date'] !== '') {
            copyDate.from_date = new Date(params['from_date'] * 1000)
            copyDate.end_date = new Date(params['end_date'] * 1000)
            setSelectFilter((prev) => ({
                ...prev,
                "from_date": new Date(params['from_date'] * 1000),
                "to_date": new Date(params['end_date'] * 1000)
            }))
        } else {
            handleFetch();
        }
        if (searchParams.get("from_date") !== null) {
            SetDateRange({

                "from_date": new Date(searchParams.get("from_date") * 1000),
                "end_date": new Date(searchParams.get("to_date") * 1000),
            })
        }
    }, [])
    

    const handleClearFilter = (graphKey, val) => {
        setLoading(falseLoadingState);
        // Deep clone the original object
        const updatedFilter = JSON.parse(JSON.stringify(selectedFilter));
        if(selectedFilter[graphKey].email_address !== '' && val === 'merchant') {
            const filters = selectedFilter;
            filters[graphKey].email_address = null,
            filters[graphKey].city = null,
            filters[graphKey].merchant = null,
            setSelectFilter({...filters})
            setLoading((prev) => ({
                ...prev,
                [graphKey]: true
            }))
        } else if (updatedFilter[graphKey][val] !== null) {
            // Update the specified key to null
            updatedFilter[graphKey][val] = null;
            // If graphKey is "products_with_nft", handle additional conditions
            if (graphKey === "products_with_nft") {
                // If val is "city", also set the "merchant" key to null
                if (val === "city") {
                    updatedFilter[graphKey].merchant = null;
                }
                // If val is "merchant", also set the "city" key to null
                if (val === "merchant") {
                    console.log('updatedFilter[graphKey].city', updatedFilter[graphKey].city)
                    updatedFilter[graphKey].city = null;
                }
            }
            setSelectFilter(updatedFilter);
            setLoading((prev) => ({
                ...prev,
                [graphKey]: true
            }))
        }
        
        // Update the state with the modified filter object
    };
    
    useEffect(() => {
        if (searchParams.get('from_date') === '' || searchParams.get('to_date') === '') {
            // Clear selected dates when either from_date or to_date is empty
            SetDateRange({
                from_date: '',
                end_date: ''
            });
        }
    }, [searchParams]);

    return (
        <CardHeader header={'Dashboard'} noIcon>
            <div className='bg-[#f5f5f5] px-[16px] py-[12px] mt-[110px] '>
                <div className='graphHeight overflow-auto  sidebar bg-white rounded'>
                    <TopBar
                        handleSetDate={handleSetDate}
                        DateRange={DateRange}
                        SetDateRange={SetDateRange}
                        handleApplyFilter={handleApplyFilter}
                        DateRangeError={DateRangeError}
                        SetDateRangeError={SetDateRangeError}
                        handleDatePickerValidation={handleDatePickerValidation}
                        DateErrorClear={() => SetDateRangeError(initialDateError)}
                    />
                    <div className=''>
                        <ApplicationDetails loadingDetails={loadingDetails} graphDetails={graphDetails} />
                        <div className='w-full flex flex-wrap'>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.number_of_merchants_onboarded} spinner text="Just a Moment!...">
                                    <LineGraph
                                        graphDetails={graphDetails.chart_data?.number_of_merchants_onboarded}
                                        selectedFilter={selectedFilter?.number_of_merchants_onboarded}
                                        handleSetFilterValues={handleSetFilterValues}
                                        cityList={cityList}
                                        MerchantList={MerchantList}
                                        City
                                        Duration
                                        Title="Number of Merchants Onboarded"
                                        GraphKey="number_of_merchants_onboarded"
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.payouts} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="payouts"
                                        graphDetails={graphDetails.chart_data?.payouts}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.payouts}
                                        handleGetCities={handleGetCities}
                                        Title="Settlements"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.products_with_nft} spinner text="Just a Moment!...">
                                    <DoughnutGraph
                                        graphDetails={graphDetails.chart_data?.products_with_nft}
                                        selectedFilter={selectedFilter?.products_with_nft}
                                        handleSetFilterValues={handleSetFilterValues}
                                        cityList={cityList}
                                        MerchantList={MerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        GraphKey='products_with_nft'
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.number_of_products_added} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="number_of_products_added"
                                        graphDetails={graphDetails.chart_data?.number_of_products_added}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.number_of_products_added}
                                        handleGetCities={handleGetCities}
                                        Title="Products Added"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.number_of_products_scanned} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="number_of_products_scanned"
                                        graphDetails={graphDetails.chart_data?.number_of_products_scanned}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.number_of_products_scanned}
                                        handleGetCities={handleGetCities}
                                        Title="Products Scanned"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.number_of_stores} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="number_of_stores"
                                        graphDetails={graphDetails.chart_data?.number_of_stores}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.number_of_stores}
                                        handleGetCities={handleGetCities}
                                        Title="Number of Stores"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.number_of_orders_placed} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="number_of_orders_placed"
                                        graphDetails={graphDetails.chart_data?.number_of_orders_placed}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.number_of_orders_placed}
                                        handleGetCities={handleGetCities}
                                        Title="Order Placed"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-1/2'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.commission_earned} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="commission_earned"
                                        graphDetails={graphDetails.chart_data?.commission_earned}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.commission_earned}
                                        handleGetCities={handleGetCities}
                                        Title="Commission Earned"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        totalMerchants={totalMerchants}
                                    />
                                </LoadingOverlay>
                            </div>
                            <div className='w-full'>
                                <LoadingOverlay className='w-full mx-auto pageheight' active={loading.number_of_items_added_to_cart} spinner text="Just a Moment!...">
                                    <LineGraph
                                        setGraphDetails={setGraphDetails}
                                        GraphKey="number_of_items_added_to_cart"
                                        graphDetails={graphDetails.chart_data?.number_of_items_added_to_cart}
                                        handleSetFilterValues={handleSetFilterValues}
                                        onMerchantChange={handleMercnantChange}
                                        selectedFilter={selectedFilter?.number_of_items_added_to_cart}
                                        handleGetCities={handleGetCities}
                                        Title="Products Added to the Cart"
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                        cityList={cityList}
                                        setCityList={setCityList}
                                        selectedMerchant={selectedMerchant}
                                        setSelectedMerchant={setSelectedMerchant}
                                        MerchantList={MerchantList}
                                        setMerchantList={setMerchantList}
                                        Merchecnt
                                        City
                                        Duration
                                        handleClearFilter={handleClearFilter}
                                        totalCity={totalCity}
                                        aspectRatio
                                    />
                                </LoadingOverlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CardHeader>
    )
}

export default Dashboard